"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.statusService = void 0;
var helpers_1 = require("../helpers/helpers");
var index_1 = require("../index");
var StatusService = /** @class */ (function () {
    function StatusService() {
        this.currentStatus = undefined;
        this.callbacks = new Map();
        this.pollTimerId = null;
        this.failTimeoutId = null;
    }
    StatusService.prototype.getStatus = function () {
        return this.currentStatus;
    };
    StatusService.prototype.setStatus = function (status) {
        // When Desktop disconnects or transfer client fails, remap to DEGRADED if HTTP Gateway is available
        if ((status === 'DISCONNECTED' || status === 'FAILED') && index_1.asperaSdk.httpGatewayIsReady) {
            status = 'DEGRADED';
        }
        if (this.currentStatus === status) {
            return;
        }
        // Manage Desktop verification state based on status transitions
        if (status === 'DISCONNECTED' || status === 'DEGRADED') {
            index_1.asperaSdk.globals.asperaAppVerified = false;
        }
        else if (status === 'RUNNING' && (this.currentStatus === 'DISCONNECTED' || this.currentStatus === 'DEGRADED')) {
            index_1.asperaSdk.globals.asperaAppVerified = true;
        }
        this.currentStatus = status;
        this.callbacks.forEach(function (cb) { return cb(status); });
    };
    StatusService.prototype.registerCallback = function (cb) {
        var id = "status-".concat((0, helpers_1.randomUUID)());
        this.callbacks.set(id, cb);
        if (this.currentStatus !== undefined) {
            cb(this.currentStatus);
        }
        return id;
    };
    StatusService.prototype.deregisterCallback = function (id) {
        this.callbacks.delete(id);
    };
    /**
     * Start Desktop detection polling loop.
     *
     * @param detectFn async function that resolves if Desktop is found, rejects if not
     * @param interval ms between attempts
     * @param failTimeout ms before transitioning to FAILED or DEGRADED
     * @param onFallback optional callback invoked on timeout instead of FAILED/DEGRADED (e.g. to start Connect)
     */
    StatusService.prototype.startPolling = function (detectFn, interval, failTimeout, onFallback) {
        var _this = this;
        this.stopPolling();
        this.setStatus('INITIALIZING');
        this.failTimeoutId = setTimeout(function () {
            if (_this.currentStatus !== 'RUNNING') {
                if (onFallback) {
                    _this.stopPolling();
                    onFallback();
                }
                else if (index_1.asperaSdk.httpGatewayIsReady) {
                    _this.setStatus('DEGRADED');
                }
                else {
                    _this.setStatus('FAILED');
                }
            }
        }, failTimeout);
        var attempt = function () {
            detectFn()
                .then(function () {
                _this.stopPolling();
                _this.setStatus('RUNNING');
            })
                .catch(function () {
                // Stay in current status (INITIALIZING or FAILED), poll continues
            });
        };
        attempt();
        this.pollTimerId = setInterval(attempt, interval);
    };
    /**
     * Resume Desktop detection polling without resetting status or setting a fail timeout.
     * Used after a fallback decision (e.g. FAILED/DEGRADED) to continue detecting Desktop
     * in the background so a late launch can still transition to RUNNING.
     *
     * @param detectFn async function that resolves if Desktop is found, rejects if not
     * @param interval ms between attempts
     */
    StatusService.prototype.resumePolling = function (detectFn, interval) {
        var _this = this;
        if (this.pollTimerId) {
            return;
        }
        var attempt = function () {
            detectFn()
                .then(function () {
                _this.stopPolling();
                _this.setStatus('RUNNING');
            })
                .catch(function () {
                // Stay in current status, poll continues
            });
        };
        attempt();
        this.pollTimerId = setInterval(attempt, interval);
    };
    StatusService.prototype.stopPolling = function () {
        if (this.pollTimerId) {
            clearInterval(this.pollTimerId);
            this.pollTimerId = null;
        }
        if (this.failTimeoutId) {
            clearTimeout(this.failTimeoutId);
            this.failTimeoutId = null;
        }
    };
    StatusService.prototype.reset = function () {
        this.stopPolling();
        this.currentStatus = undefined;
        this.callbacks.clear();
    };
    return StatusService;
}());
exports.statusService = new StatusService();
